import { Component, OnInit } from '@angular/core';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { ActivatedRoute } from '@angular/router';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { SeoService } from 'src/app/services/seo.service';
@Component({
  selector: 'app-proyecto',
  templateUrl: './proyecto.component.html',
  styleUrls: ['./proyecto.component.scss']
})
export class ProyectoComponent implements OnInit {


  months: any = [
    { value: '01', label: 'Enero', },
    { value: '02', label: 'Febrero', },
    { value: '03', label: 'Marzo', },
    { value: '04', label: 'Abril', },
    { value: '05', label: 'Mayo', },
    { value: '06', label: 'Junio', },
    { value: '07', label: 'Julio', },
    { value: '08', label: 'Agosto', },
  ];

  lastPage: number = 0;
  page: number = 0;

  context: any;
  blog: any;

  webcontext: any;
  contextSelected: any

  private routeObs: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public seo: SeoService,
    public api: RestapiService
  ) {

    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        delete this.blog;
        this.page = 0;
        this.lastPage = 0;
        this.context = this.activatedRoute.snapshot.paramMap.get('context');
        this.loadContent();
      }, 10);
    });
   }

  ngOnInit(): void {
    this.blog = [];
    this.context = this.activatedRoute.snapshot.paramMap.get('context');
    this.loadContent();
    this.api.getdata('webcontext', { per_page: 100 ,  filters: { webroute_id: { value: 7 }} })
    .subscribe(res => {
      res.status == true ? this.webcontext = res.result.data : '';
    });
  }
  pickContext(item){
    this.route.goTo('proyecto-en-imagenes/'+item.name)
  }

  loadContent() {

    this.page++;
    this.page === 1 ? this.blog = [] : '';
    this.api.getdata('websection', {
      page: this.page,
      per_page: 10,
      filters: { webroute_id: { value: 7 } , webcontext_id: { model: 'webcontext', value: this.context , field:'name', operator:'belongsTo' } }
    }).subscribe(res => {
      if (res.status == true) {
        console.log('websection', res);
        this.lastPage = res.result.last_page;
        if (res.result.data.length > 0) {
          res.result.data.forEach(el => {
            this.blog.push(el);
          });
        }
        this.seo.generateTags({
          title:'WWF Educación Ambiental, '+'Proyecto en imágenes',
          description: 'Proyecto en imágenes',
          image: '/assets/brand.png',
          slug: window.location.href,
        });
      }
    })
  }

  onScroll() {
    if (this.page < this.lastPage) {
      this.loadContent();
    } else {
      console.log('No more lines. Finish page!');
    }
  }

}
